// extracted by mini-css-extract-plugin
module.exports = {"soldBy":"soldBy_soldBy__Mvsrp","isHorizontal":"soldBy_isHorizontal__hZD17"};